import React from 'react';
import styled from 'styled-components';
import { H3, H6, P, PSmall } from '../../../components/Typography/Typography';
import * as Icons from '../../../icons/Icons';
import { media } from '../../../components/style-utils';

export const SectionDeliverable = function() {
  return (
    <Container>
      <Header>
        <HeaderHeadline>Course Curriculum</HeaderHeadline>
        <HeaderStatement>
          Learn the 6-part process for using social media to accomplish your church’s biggest goals
        </HeaderStatement>
        <HeaderIcon>
          <Icons.Folder checked={true} />
        </HeaderIcon>
      </Header>

      <DeliverableList>
        <DeliverableItem>
          <DeliverableHeadline>Your Social Media Manifesto</DeliverableHeadline>
          <DeliverableStatement>
            Learn the necessary process for aligning your church’s vision with your social media efforts (this is the
            crucial first step most churches misunderstand)
          </DeliverableStatement>
        </DeliverableItem>

        <DeliverableItem>
          <DeliverableHeadline>The Content Engine</DeliverableHeadline>
          <DeliverableStatement>
            Identify your key social platforms and build your content engine (never get stuck wondering what to post on
            social ever again)
          </DeliverableStatement>
        </DeliverableItem>

        <DeliverableItem>
          <DeliverableHeadline>Design & Tech</DeliverableHeadline>
          <DeliverableStatement>
            You’re not creative enough? Don’t have the gear you need? Lies. Here we’ll turn you into a design & tech
            master.
          </DeliverableStatement>
        </DeliverableItem>

        <DeliverableItem>
          <DeliverableHeadline>Social For Internal Growth</DeliverableHeadline>
          <DeliverableStatement>
            Now you’re ready to start using social to accomplish your church’s biggest goals. We’ll start with your
            existing congregation - focusing on next steps and engagement.
          </DeliverableStatement>
        </DeliverableItem>

        <DeliverableItem>
          <DeliverableHeadline>Social For External Growth</DeliverableHeadline>
          <DeliverableStatement>
            Next we’ll turn our focus to growing your church. Here you’ll learn the process for using social to generate
            a steady stream of new visitors to your church.
          </DeliverableStatement>
        </DeliverableItem>

        <DeliverableItem>
          <DeliverableHeadline>Social For Increased Giving</DeliverableHeadline>
          <DeliverableStatement>
            Can social really be used to increase giving at your church? Undoubtedly. In this module, you’ll learn how
            to do it the right way (and avoid the common mistakes).
          </DeliverableStatement>
        </DeliverableItem>
      </DeliverableList>

      <Header>
        <HeaderHeadline>Hands-On Mentorship</HeaderHeadline>
        <HeaderStatement>
          Accelerate your growth with unlimited 1-on-1 email access, attend weekly live training calls, and connect with
          other churches on the same path
        </HeaderStatement>
        <HeaderIcon>
          <Icons.Learn checked={true} />
        </HeaderIcon>
      </Header>
      <DeliverableList>
        <DeliverableItem>
          <DeliverableHeadline>
            We’re committed to your church’s success. And that’s why the hands-on mentorship element of The 167 is such
            a priority for us.
          </DeliverableHeadline>
          <DeliverableStatement>
            The curriculum and training will provide you the action steps and foundation to get going - coaching fills
            in the gaps to get you unstuck.
          </DeliverableStatement>
        </DeliverableItem>
      </DeliverableList>

      <Header>
        <HeaderHeadline>The 1-Year Social Media&nbsp;Calendar</HeaderHeadline>
        <HeaderStatement>
          Gain instant access to 365 planned out social media posts that will cover you for the full year (plus, all the
          source files & templates)
        </HeaderStatement>
        <HeaderIcon>
          <Icons.Calendar checked={true} />
        </HeaderIcon>
      </Header>
      <DeliverableList>
        <DeliverableItem>
          <DeliverableHeadline>
            Over the years of developing social content for churches, we’ve identified the posts that perform best and
            drive the most meaningful engagement - you’ll get all of them!
          </DeliverableHeadline>
          <DeliverableStatement>
            A new post for every single day of the year. So on the days where your focus needs to be elsewhere, you’ll
            always have an archive of pre-planned social content to pull from.
          </DeliverableStatement>
        </DeliverableItem>
      </DeliverableList>

      <Header>
        <HeaderHeadline>Execution Plans</HeaderHeadline>
        <HeaderStatement>
          Look over Brady’s shoulder as he builds, optimizes, and executes high-level social media strategies.
        </HeaderStatement>
        <HeaderIcon>
          <Icons.Teaching checked={true} />
        </HeaderIcon>
      </Header>
      <DeliverableList>
        <DeliverableItem>
          <DeliverableHeadline>
            Here we’ll dive deep into the granular level of social media content creation.
          </DeliverableHeadline>
          <DeliverableStatement>
            This is Brady’s testing lab for social content (so if you’re a nerd like him, you’ll love this).
          </DeliverableStatement>
        </DeliverableItem>
      </DeliverableList>
    </Container>
  );
};

const Container = styled.section`
  /* padding-top: 9rem; */
  width: 100vw;
  padding-bottom: 5rem;

  ${media.desktopAndUp`
    padding-bottom: 10rem;
  `}
`;

const Header = styled.div`
  position: relative;
  margin-top: 13rem;
  padding: 8rem 1.2rem 5rem;

  color: var(--colorWhite);
  background-color: var(--colorBlack);

  ${media.tabletLandscapeAndUp`
    padding-top: 3rem;
  `}

  ${media.desktopAndUp`
    margin-left: auto;
    margin-right: auto;
    transform: translateX(-6.2rem);

    border-radius: 13rem 1.4rem 1.4rem 13rem;


    max-width: 100rem;
    height: 26rem;
    padding: 0 3rem 0 23.5rem;

    display: flex;
    flex-direction: column;
    justify-content: center;
  `}
`;

const HeaderHeadline = styled(H3)`
  max-width: 60rem;
  margin-left: auto;
  margin-right: auto;

  margin-bottom: 1rem;

  ${media.desktopAndUp`
    margin-top: 0;
    margin-left: 0;
    margin-right: 0;
  `}
`;

const HeaderStatement = styled(P)`
  max-width: 60rem;
  margin: 0 auto;

  ${media.desktopAndUp`
    margin-left: 0;
    margin-right: 0;
  `}
`;

const HeaderIcon = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  transform: translate(1.2rem, -50%);

  width: 13.6rem;
  height: 13.6rem;

  background-color: var(--colorWhite);
  border-radius: 50%;
  border: solid var(--colorBlack) 1.2rem;

  display: flex;
  justify-content: center;
  align-items: center;

  ${Icons.SVG} {
    height: 5.5rem;
  }

  ${media.desktopAndUp`
    transform: translate(calc((26rem - 13.6rem) / 2), calc((26rem - 13.6rem) / 2));
  `}
`;

const DeliverableList = styled.ul`
  max-width: 70rem;
  margin-left: auto;
  margin-right: auto;

  ${media.desktopAndUp`
    max-width: 90rem;
  `}
`;

const DeliverableItem = function(props) {
  return (
    <StyledDeliverableItem {...props}>
      <DeliverableIcon />
      {props.children}
    </StyledDeliverableItem>
  );
};

const StyledDeliverableItem = styled.li`
  position: relative;
  margin: 1.2rem;

  padding: 2.4rem 5rem 2.4rem 7rem;
  border-radius: 1rem;

  box-shadow: 0 0.2rem 0.4rem 0 rgba(0, 0, 0, 0.27);

  ${media.tabletLandscapeAndUp`
    padding-left: 13rem;
  `};

  ${media.desktopAndUp`
    padding-right: 15rem;
  `}
`;

const DeliverableHeadline = styled(H6)`
  margin: 0 0 0.8rem;
  font-weight: 700;
  line-height: 1.2em;
`;

const DeliverableStatement = styled(PSmall)`
  margin: 0;
`;

const DeliverableIcon = styled(Icons.Checkbox)`
  position: absolute;
  top: 2.4rem;
  left: 2.4rem;
  width: 3rem;

  ${media.tabletLandscapeAndUp`
    top: calc(50% - 2rem);
    left: 4.5rem;
    width: 4rem;
  `};
`;



// WEBPACK FOOTER //
// ./src/routes/Home/components/SectionDeliverable.js